import { defineComponent as _defineComponent } from 'vue'
import {getCurrentInstance} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {useZoom, ZoomLevel} from '@/components/calculator/results/useZoom';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationToolbarZoom',
  setup(__props) {

const instance = getCurrentInstance();
const store = useSimulationStore();
const {zoomLevel, AVAILABLE_ZOOM_LEVELS,} = useZoom(
  store.productType!,
  instance?.proxy.$vuetify.breakpoint.mdAndDown
);

return { __sfc: true,instance, store, zoomLevel, AVAILABLE_ZOOM_LEVELS, ZoomLevel }
}

})